import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FrattaleService {

  url: string = 'http://localhost/www/tradingfrattale/src/php/'
  remoteUrl: string = 'https://tradingfrattale.it/TASM/php/'
  head: HttpHeaders = new HttpHeaders


  //private dataReportM12: any


  constructor(protected http: HttpClient) {

    this.head.set('tasm', 'prova')

    if (window.location.hostname.indexOf('localhost') < 0) {
      this.url = './php/'
    }
    if (window.location.hostname.indexOf('tradingfrattale.test') > -1) {
      this.url = 'http://tradingfrattale.test/php/'
    }
    /* switch (localStorage.getItem('utente')){
      case "tommaso":
        this.url = 'http://localhost/www/tradingfrattale/php/'
        break
      case "giovanni":
        break
      default:
        this.url = 'http://localhost/www/tradingfrattale/php/'
    } */
  }

  isLocalhost(): boolean {
    return (window.location.hostname.indexOf('localhost') > -1) as unknown as boolean
  }

  getMarketsSymbols() {
    let data = {
      action: "markets"
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  bangType1(dati: any) {
    let data = {
      mkt: dati.mkt,
      stoploss: dati.stoploss,
      numerobarre: dati.numerobarre,
      seriebarre: dati.seriebarre,
      barraminima: dati.barraminima,
      chkTP: dati.checkTP,
      TP: dati.TP,
      noe: dati.verso,
      pask: dati.pask,
      cmd: "calcola",
      action: "bang_analisi"
    }
    console.log(data)
    return this.http.post(this.url, data, { headers: this.head })
  }

  getDailyBang() {
    let p = { action: 'dbang_10y', cmd: 'list_profit' }
    return this.http.post(this.url, p, { headers: this.head })
  }

  getDailyBangRawal() {
    let p = { action: 'dbang_10y_rawal', cmd: 'list_profit' }
    return this.http.post(this.url, p, { headers: this.head })
  }

  simulator(periodo: string) {
    let p = { action: 'simulatore', periodo: periodo }
    return this.http.post(this.url, p, { headers: this.head })
  }

  dbangOperative() {
    let p = { action: 'dbang-operative' }
    return this.http.post(this.url, p, { headers: this.head })
  }

  dbangPreferiti() {
    let p = { action: 'dbang-preferiti', cmd: 'lista' }
    return this.http.post(this.url, p, { headers: this.head })
  }

  dbangSavePreferiti(dati: any) {
    let p = { action: 'dbang-preferiti', cmd: 'save', market: dati.market, verso: dati.verso, swing: dati.swing, dayweek: dati.dayweek, preferito: dati.preferito }
    return this.http.post(this.url, p, { headers: this.head })
  }


  btDaily(mkt: string, day: number, swing: string, verso: string) {
    let p = { action: 'dbang', cmd: 'btMarket', mkt: mkt, dayweek: day, swing: swing, verso: verso }
    return this.http.post(this.url, p, { headers: this.head })
  }

  daxTrendSave(verso: any, id: any, settimana: number, flag: number) {
    let p = { action: 'dax_trend', cmd: 'salva', verso: verso, id: id, settimana: settimana, flag: flag }
    return this.http.post(this.url, p, { headers: this.head })
  }

  daxTrendRead() {
    let p = { action: 'dax_trend', cmd: 'leggi' }
    return this.http.post(this.url, p, { headers: this.head })
  }

  daxTrendUpdateMonth(id: number, verso: string, flag: number) {
    let p = { action: 'dax_trend', cmd: 'updateMonth', id: id, verso: verso, flag: flag }
    return this.http.post(this.url, p, { headers: this.head })
  }

  daxTrendUpdatePerc(obj: any) {
    let p = { action: 'dax_trend', cmd: 'updatePerc', buy: obj.percBuy, sell: obj.percSell }
    return this.http.post(this.url, p, { headers: this.head })
  }

  fractimeStorico() {
    let p = { action: 'fractime-storico', cmd: 'list' }
    return this.http.post(this.url, p, { headers: this.head })
  }

  fractimePref(id: number, flag: number) {
    let p = { action: 'fractime-storico', cmd: 'updatePref', id: id, selezionato: flag }
    return this.http.post(this.url, p, { headers: this.head })
  }

  fractimeSelezionati() {
    let p = { action: 'fractime-storico', cmd: 'selezionati' }
    return this.http.post(this.url, p, { headers: this.head })
  }

  backtestMarkets() {
    return this.http.post(this.url, { action: 'backtester', cmd: 'lista' }, { headers: this.head })
  }

  backtest(market: string) {
    return this.http.post(this.url, { action: 'backtester', cmd: 'bt', market: market }, { headers: this.head })
  }

  getMarkets() {
    return this.http.post(this.url, { action: 'markets' }, { headers: this.head })
  }

  lastValues(market: string, ora: null) {
    if (window.location.hostname.indexOf('localhost') < 0) {
      market = market.toUpperCase()
    }
    return this.http.post(this.url, { action: 'lastvalues', market: market, ora: ora }, { headers: this.head })
  }
/* 
  updateReports_pp_m12(mkt: string) {
    return this.http.post(this.url, { action: 'update_reports_m12', market: mkt }, { headers: this.head })
  } */


  addPref(id: any) {
    return this.http.post(this.url, { action: 'reports_pref', 'cmd': 'add', id: id }, { headers: this.head })
  }


  /* report_m12() {
    if (this.dataReportM12) {
      return of(this.dataReportM12)
    }
    return this.http.post(this.url, { action: 'reports_m12' }, { headers: this.head })
  } */

  realTimeHilo(mkt: string) {
    return this.http.post(this.url, { action: 'realtime_hilo', market: mkt }, { headers: this.head })
  }

  reverseM45(mkt: string, min: number, ora: number) {
    let p = { action: 'reverse_m45', cmd: 'lista', market: mkt, minuto: min, oraclose: ora }
    return this.http.post(this.url, p, { headers: this.head })
  }

  updateDB(market: string, ora: string) {
    return this.http.post(this.url, { action: 'updateDB', market: market, ora: ora }, { headers: this.head })
  }

  marketData(mkt: string, timeframe: string) {
    let p = { action: 'ohlc', cmd: timeframe, mkt: mkt}
    return this.http.post(this.url, p, { headers: this.head })
  }

  aggiornaStoricoFractime(mkt: string) {
    let p = { action: 'fractime-storico', cmd: 'update', mkt: mkt }
    return this.http.post(this.url, p, { headers: this.head })
  }

  datepickerLangIT(){
    return {
      title: 'Seleziona la data',
      monthsFull: [
        'Gennaio',
        'Febbraio',
        'Marzo',
        'Aprile',
        'Maggio',
        'Giugno',
        'Luglio',
        'Agosto',
        'Settembre',
        'Ottobre',
        'Novembre',
        'Dicembre',
      ],
      monthsShort: [
        'Gen',
        'Feb',
        'Mar',
        'Apr',
        'Mag',
        'Giu',
        'Lug',
        'Ago',
        'Set',
        'Ott',
        'Nov',
        'Dic',
      ],
      weekdaysFull: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
      weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
      weekdaysNarrow: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
      okBtnText: 'Ok',
      clearBtnText: 'Pulisci',
      cancelBtnText: 'Annulla',
    }
  }

}
